/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useEffect, useState } from 'react';

export function usePublications(participant: VideoProvider.IParticipant) {
  const [publications, setPublications] = useState<VideoProvider.ITwilioPublication[]>([]);

  useEffect(() => {
    setPublications(Array.from(participant.tracks?.values() || []));

    const publicationAdded = (publication: VideoProvider.ITwilioPublication) => {
      setPublications(prevPublications => [...prevPublications, publication]);
    };
    const publicationRemoved = (publication: VideoProvider.ITwilioPublication) => {
      setPublications(prevPublications => prevPublications.filter(p => p !== publication));
    };

    participant.on?.('trackPublished', publicationAdded);
    participant.on?.('trackUnpublished', publicationRemoved);
    return () => {
      participant.off?.('trackPublished', publicationAdded);
      participant.off?.('trackUnpublished', publicationRemoved);
    };
  }, [participant]);

  return publications;
}
